import React from 'react';
import QnaSide from '../../components/Qna/Qna/QnaSide';
import QnaDetailView from '../../components/Qna/Qna/QnaDetailView';

const QnaDetail = () => {
  return (
    <div className='bg-grayscale-gray01 min-h-screen tabletH:px-20 tabletH:pt-10 '>
      <div className='w-full flex'>
        <div className='flex-shrink-0 mr-6 hidden tabletH:block'>
          <QnaSide showCategory={false} qnaDetail={true} />
        </div>
        <div className='flex-grow'>
          <QnaDetailView />
        </div>
      </div>
    </div>
  );
};

export default QnaDetail;
